import { render, staticRenderFns } from "./UEditorDemo.vue?vue&type=template&id=42ec1480"
import script from "./UEditorDemo.vue?vue&type=script&lang=js"
export * from "./UEditorDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports